import logger from 'js-logger';

import Tasks from 'APP/Tasks';
import { handleDeviceStatusUpdate } from 'APP/Tasks/realtimeEvent/handlers/handleDeviceStatusUpdate';
import { IDeviceStatusUpdateEvent } from 'APP/model/counter/counterModel.types';
import {
  subscribeCallIncomingRealtimeEvent,
  subscribeCallsActiveRealtimeEvent,
  subscribeCallSingleUpdateRealtimeEvent,
  subscribeChatSingleUpdateRealtimeEvent,
  subscribeChatStateChangedRealtimeEvent,
  subscribeChatsUpdateRealtimeEvent,
  subscribeDeleteMessages,
  subscribePushNotificationRealtimeEvent,
  subscribeUpdateMessages,
  subscribeUsersStatusUpdateRealtimeEvent,
  subscribeUserStatusSingleUpdateRealtimeEvent,
  subscribeUserTypingMessage,
  subscribeMessageSent,
  subscribeCalendarEventUpdate,
  subscribeSessionInvalidated,
  subscribeDeviceStatusUpdatedUntrustedRealtimeEvent,
  subscribeDeviceStatusUpdatedRealtimeEvent,
} from 'APP/model/realtimeEvent/realtimeEventModel';
import { wsAppSubscribeManager } from 'APP/wsApi/wsAppApi/WsAppApi';
import { subscribeRealtimeEventsRequest } from 'APP/wsApi/wsAppApi/requests/realtimeEventsRequests';
import { untrustedWsAppSubscribeManager } from 'APP/wsApi/wsAppApi/untrustedWsAppApi/UntrustedWsAppApi';

import {
  handleBatchedActiveCalls,
  handleChangeActiveCall,
  handleStartedCall,
} from './handlers/callsHandlers';
import {
  handleBatchedCounters,
  handleBatchedGroupUpdates,
  handleChangeCounter,
} from './handlers/counterHandlers';
import { handleDeleteMessage } from './handlers/deleteMessageHandler';
import { handleCalendarEventUpdate } from './handlers/handleCalendarEventUpdate';
import { handleMessageSent } from './handlers/messageSentHandler';
import {
  handleBatchedOnlineStatuses,
  handleChangeOnlineStatus,
} from './handlers/onlineStatusHandlers';
import { handlePushNotification } from './handlers/pushNotificationsHandlers';
import { handleUpdateMessages } from './handlers/updateMessagesHandler';
import { handleUserTypingMessage } from './handlers/userTypingMessageHandler';

let listeners: Array<() => void> = [];
let untrustedListeners: Array<() => void> = [];

export function initRealtimeEvents(): Promise<void> {
  listeners = [
    subscribeCallsActiveRealtimeEvent(handleBatchedActiveCalls),
    subscribeCallSingleUpdateRealtimeEvent(handleChangeActiveCall),
    subscribeCallIncomingRealtimeEvent(handleStartedCall),
    subscribeChatsUpdateRealtimeEvent(handleBatchedCounters),
    subscribeChatSingleUpdateRealtimeEvent(handleChangeCounter),
    subscribeChatStateChangedRealtimeEvent(handleBatchedGroupUpdates),
    subscribeUsersStatusUpdateRealtimeEvent(handleBatchedOnlineStatuses),
    subscribeUserStatusSingleUpdateRealtimeEvent(handleChangeOnlineStatus),
    subscribePushNotificationRealtimeEvent(handlePushNotification),
    subscribeUpdateMessages(handleUpdateMessages),
    subscribeDeleteMessages(handleDeleteMessage),
    subscribeUserTypingMessage(handleUserTypingMessage),
    subscribeMessageSent(handleMessageSent),
    subscribeCalendarEventUpdate(handleCalendarEventUpdate),
    subscribeSessionInvalidated(() => Tasks.authorization.logout(false, true)),
    subscribeDeviceStatusUpdatedRealtimeEvent(handleDeviceStatusUpdate),
  ];

  try {
    listeners.push(
      wsAppSubscribeManager.subscribe(async () => {
        await subscribeRealtimeEventsRequest();
      })
    );
  } catch (e) {
    logger.log(e);
  }

  return Promise.resolve();
}

export function dispatchRealtimeEvents(): void {
  listeners.forEach((unsubscribe) => {
    unsubscribe();
  });
  listeners = [];
}

export function initUntrustedRealtimeEvents(
  handleStatusUpdated: (data: IDeviceStatusUpdateEvent) => void
): Promise<void> {
  untrustedListeners = [subscribeDeviceStatusUpdatedUntrustedRealtimeEvent(handleStatusUpdated)];

  try {
    untrustedListeners.push(
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      untrustedWsAppSubscribeManager.subscribe(() => {})
    );
  } catch (e) {
    logger.log(e);
  }

  return Promise.resolve();
}

export function dispatchUntrustedRealtimeEvents(): void {
  untrustedListeners.forEach((unsubscribe) => {
    unsubscribe();
  });
  untrustedListeners = [];
}
